module.exports = __webpack_public_path__ + "img/GT.5c2993cb.svg";